import { call, put, select } from 'redux-saga/effects'
import * as client from '../../api/client'
import * as actions from '../action_creators'
import socket from '../../api/socket_client'
import { removeToken} from '../../util/jwt_utils'
import { handleOnboardingBootstrap } from './bootstrap_sagas'
import { getProfile, getNavigation } from '../selectors'
import { convertProfileRemoteToRedux } from '../../util/redux_utils'
import { makeToast } from '../../util/toast_util'
import moment from "moment-timezone"
import history from '../history'
import { sitka } from '../store'

export function* handleSignout() {
    removeToken()
    removeToken('tmp-token')
    socket.disconnect()
    yield call(sitka.getModules().navigation.handleClearRedirect)
    yield put(actions.reset())
}

export function* handleSignIn({ accountMeta }) {
    const { email: rawEmail, password } = accountMeta
    const meta = {
        email: rawEmail.toLowerCase(),
        password,
    }

    try {
        yield call(client.signIn, meta)
    }
    catch(e) {
        yield put(actions.setAlerts('incorrectPassword', 'signIn'))
        yield put(actions.signOut)
        return
    }

    const navigation = yield select(getNavigation)
    yield put(actions.startBootstrap())
    const { redirect, location } = navigation
    if (redirect) {
        yield call(history.push, location.pathname)
    }
}

export function* handleSignUp({accountMeta, history}) {
    const { email: rawEmail, tier, cycle } = accountMeta
    const email = rawEmail.toLowerCase()
    const timezone = moment.tz.guess()
    const profile = yield select(getProfile)
    try {
        yield call(client.signUp, { email, timezone, tier, cycle })
        const profileIngressShape = convertProfileRemoteToRedux(profile)
        // set onboarding step to navigate to verification
        yield put(
            actions.receiveProfile({
                ...profileIngressShape,
                onboardingStep: "1",
                timezone,
            }),
        )
    }

    catch(e) {
        const msg = "User already registered"
        const toastAction = {
            onClick: () => {
                history.push("/signIn")
            },
            text: "Sign In",
        }
        yield call(makeToast, msg, "danger", toastAction)
        return
    }

    localStorage.setItem("email", email)
    yield call(handleOnboardingBootstrap)
}

export function* handleHardReset() {
    yield put(actions.reset())
    yield put(actions.setBootstrapped(false))
    yield put(actions.startBootstrap())
    yield window.location.reload(true)
}



// WEBPACK FOOTER //
// ./src/redux/sagas/session_saga.js